'use strict'

const imageStyleSection = require('../sections/image/imageStyleSection')

module.exports = {
    imageStyleSection
}
